import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import type { PeopleInsightsData } from 'modules/job_catalog/lib/peopleInsights'

import { JobCatalogGenderChart } from './GenderChart'
import { useJobCatalogGenderDataFromInsights } from './useJobCatalogGenderData'

interface JobCatalogPeopleChartsProps {
  insights: PeopleInsightsData | null
  loading: boolean
  groupedBy: string
  isLevel: boolean
}

const ChartSkeleton = () => (
  <Box
    border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
    borderRadius={{ all: 'abs008' }}
    padding="s24"
    width="full"
  >
    <Skeleton height="s16" width="s200" isLoading />
    <Box flexDirection="row" gap="s80" paddingTop="s24" paddingBottom="s24">
      <Box flexDirection="column" gap="s4">
        <Skeleton height="s32" width="s48" isLoading />
        <Skeleton height="s16" width="s64" isLoading />
      </Box>
      <Box flexDirection="column" gap="s4">
        <Skeleton height="s32" width="s48" isLoading />
        <Skeleton height="s16" width="s64" isLoading />
      </Box>
      <Box flexDirection="column" gap="s4">
        <Skeleton height="s32" width="s48" isLoading />
        <Skeleton height="s16" width="s64" isLoading />
      </Box>
      <Box flexDirection="column" gap="s4">
        <Skeleton height="s32" width="s48" isLoading />
        <Skeleton height="s16" width="s64" isLoading />
      </Box>
    </Box>
    <Box height="s240" width="full">
      <Box flexDirection="row" alignItems="flexEnd" gap="s16" height="full">
        <Skeleton height="s120" width="s24" isLoading />
        <Skeleton height="s80" width="s24" isLoading />
        <Skeleton height="s140" width="s24" isLoading />
        <Skeleton height="s96" width="s24" isLoading />
        <Skeleton height="s140" width="s24" isLoading />
      </Box>
    </Box>
  </Box>
)

export const JobCatalogPeopleCharts = ({
  insights,
  loading,
  groupedBy,
  isLevel,
}: JobCatalogPeopleChartsProps) => {
  if (loading || !insights) {
    return (
      <Box flexDirection={'row'} gap="s24">
        <ChartSkeleton />
      </Box>
    )
  }

  return (
    <JobCatalogPeopleChartsContent insights={insights} groupedBy={groupedBy} isLevel={isLevel} />
  )
}

const JobCatalogPeopleChartsContent = ({
  insights,
  groupedBy,
  isLevel,
}: {
  insights: PeopleInsightsData
  groupedBy: string
  isLevel: boolean
}) => {
  const { data, keys, nameById, count, malePercentage, femalePercentage, notDeclaredPercentage } =
    useJobCatalogGenderDataFromInsights(insights, isLevel)
  return (
    <Box flexDirection={'row'} gap="s24">
      <JobCatalogGenderChart
        data={data}
        keys={keys}
        nameById={nameById}
        count={count}
        malePercentage={malePercentage}
        femalePercentage={femalePercentage}
        notDeclaredPercentage={notDeclaredPercentage}
        groupedBy={groupedBy}
      />
    </Box>
  )
}
